import displayDatatablesPagination from '../shared/datatables_pagination';
import { withSaveState } from '../shared/datatables_state';
import {
  overridePaginationClasses,
  customizeDOMPaginationClasses
} from '../../datatables/customization-v2';
import {
  setup as tableSetup,
  setupPaginationOnDOM,
  tearDownPaginationOnDOM,
  customizePageLength,
  evaluateSelectedRows,
  defaultTableOptions
} from '../../datatables/table-setup';

export const POINTS_ACTIONS_TABLE_SELECTOR = '.points-actions';

const PointsActionsTable = {
  start() {
    const $pointsActionsTable = $(`${POINTS_ACTIONS_TABLE_SELECTOR}:not(.dataTable)`);
    if (!$pointsActionsTable.length) {
      return;
    }
    this.startPointsActionsTable($pointsActionsTable);
  },

  tearDown() {
    $(`${POINTS_ACTIONS_TABLE_SELECTOR}.dataTable`).DataTable().destroy();
    tearDownPaginationOnDOM();
  },

  startPointsActionsTable($pointsActionsTable) {
    overridePaginationClasses();
    const $checkAllCheckbox = $('#checkall');
    let table;

    const tableOptions = {
      ...defaultTableOptions,
      order: [[1, 'asc']],
      dom: 'rtp',
      select: {
        style: 'multi',
        selector: 'label.js-checkbox-for-row',
        className: 'is-selected'
      },
      columnDefs: [
        { targets: [0], orderable: false, width: '7%' },
        { targets: [1], orderable: true, width: '8%' },
        { targets: [2], searchable: true, width: '25%' },
        { targets: [3], searchable: false, width: '20%' },
        { targets: [4], searchable: false, width: '15%' },
        { targets: [5], searchable: false, width: '15%' },
        { targets: [6], orderable: false, width: '10%' },
        { targets: '_all', searchable: false }
      ],
      drawCallback() {
        customizePageLength(this);
        customizeDOMPaginationClasses();
        evaluateSelectedRows(table, $checkAllCheckbox, false);
        displayDatatablesPagination(this);
      },
      initComplete: () => {
        setupPaginationOnDOM();
      },
      language: {
        ...defaultTableOptions.language,
        zeroRecords: '<span class="alert alert--info">Sorry, no matching Points Actions were found</span>',
        emptyTable: '<span class="alert alert--info">No Points Actions available</span>'
      }
    };

    const tableOptionsWithSaveState = withSaveState($pointsActionsTable, tableOptions);
    table = $pointsActionsTable.DataTable(tableOptionsWithSaveState);
    tableSetup(table);
  }
};

export default PointsActionsTable;
